import React from "react";
import {getIsCroft} from "../../utils/croft";

export default () => {
    const isCroft = getIsCroft();
    
    const email = isCroft ? "info@croftcircuit.co.uk" : "info@thruxtonracing.co.uk";
    
    return <a href={`mailto:${email}`}>{email}</a>
}